import { api } from '@shared/services/api';
import { url } from 'constants/urls';

export interface CheckoutRequestBody {
  country: string
  currency: string
  lastSeenPrice: number
  locale: string
  offerId: string
  offerType: string
  quantity: number
  userId: string
  chainId: number
}

export const checkout = async (data: CheckoutRequestBody) => {
  const response = await api.post(url.checkout, data);

  return response.data;
};
